<template>
    <CModal
        :title="dialogTitle"
        :show.sync="dialogVisible"
    >
        <CForm slot="default">
            <CInput
                v-model="model.title"
                :horizontal="true"
                label="Название"
                placeholder="Название категории"
            />
            <CSelect
                :value.sync="model.type"
                :horizontal="true"
                :options="categoryTypeList"
                label="Тип"
                placeholder="Выберите тип"
            />
        </CForm>

        <div slot="footer">
            <CButton
                color="light"
                class="ml-3"
                @click="close">Отмена</CButton>

            <CButton
                color="primary"
                class="ml-3"
                @click="submit">{{ submitButtonTitle }}</CButton>
        </div>
    </CModal>
</template>

<script>
    import Vue from 'vue'
    import { morphism } from 'morphism'

    export default {
        name: 'CategoryUpsertDialog',

        props: {
            entity: {
                type: Object,
                default: () => ({})
            }
        },

        data: () => ({
            dialogVisible: false,
            model: {
                enabled: true
            },
            schema: {
                id: 'id',
                title: 'title',
                type: 'type',
            },
            categoryTypeList: [{
                value: 'restaurant',
                label: 'Рестораны'
            }]
        }),

        computed: {
            dialogTitle() {
                return typeof this.entity.id === 'number'
                    ? 'Редатирование категории'
                    : 'Создание категории'
            },

            submitButtonTitle() {
                return typeof this.entity.id === 'number'
                    ? 'Сохранить'
                    : 'Создать'
            }
        },

        watch: {
            'dialogVisible': async function(v) {
                if (v) {
                    this.setModel(this.entity);
                    await this.getTypes();
                }
            }
        },

        methods: {
            open() {
                this.dialogVisible = true
            },

            close() {
                this.dialogVisible = false
            },

            setModel(source) {
                this.model = morphism(this.schema, source);
            },

            async getTypes() {
                Vue.axios.get('/entities-type')
                    .then(resp => {
                        resp.data.forEach(({ code, title }) => {
                            const condidate = this.categoryTypeList.find(type => type.value === code);
                            if (!condidate) {
                                this.categoryTypeList.push({
                                    value: code,
                                    label: title
                                });
                            }
                        });
                    })
                    .catch((err) => {
                        this.$root.$emit('showError', 'Ошибка загрузки данных. ' + err);
                    });
            },

            async submit() {
                if(!this.model.title) {
                    this.$root.$emit('showError', 'Название не может быть пустым.');
                    return;
                }

                if(!this.model.type) {
                    this.$root.$emit('showError', 'Тип не может быть пустым.');
                    return;
                }

                try {
                    const { id, ...payload } = this.model;

                    if (typeof id === 'number') {
                        await this.axios.put(`/categories/${id}`, payload)
                    } else {
                        await this.axios.post('/categories', payload)
                    }

                    this.$emit('success')
                    this.close()
                } catch (err) {
                    this.$root.$emit('showError', 'Ошибка создания категории. ' + err);
                }
            }
        }
    }
</script>
